/**
 *  Add more events by visiting https://ads.pinterest.com/advertiser/549756314300/conversions/tag/ and then press
 *  three dots on the tag of interest > Configure base code > Manually add tag code to the website > Install event code
 */
import { __decorate } from "tslib";
import { _Memo } from '@naturalcycles/js-lib';
import { pinterestPixel } from './pinterest.pixel';
class PinterestClient {
    constructor() {
        this.pixelId = '2614130247850';
    }
    load() {
        pinterestPixel(this.pixelId);
    }
    pageView({ id }) {
        this.load();
        window.pintrk('track', 'pagevisit', {
            event_id: id,
        });
    }
    lead({ id, hashedEmail }) {
        this.load();
        window.pintrk('track', 'lead', {
            event_id: id,
            lead_type: 'Newsletter',
            em: hashedEmail,
        });
    }
    addToCart({ id, amount, currency, plan }) {
        this.load();
        window.pintrk('track', 'addtocart', {
            event_id: id,
            value: amount,
            currency,
            line_items: [
                {
                    product_name: plan,
                },
            ],
        });
    }
    purchase({ id, amount, currency, plan, hashedEmail }) {
        this.load();
        window.pintrk('track', 'checkout', {
            event_id: id,
            value: amount,
            currency,
            line_items: [
                {
                    product_name: plan,
                },
            ],
            em: hashedEmail,
        });
    }
}
__decorate([
    _Memo()
], PinterestClient.prototype, "load", null);
export const pinterestClient = new PinterestClient();
